export let requirement_title = 'What describes you best?';
export let requirement_placeholder = 'Select your requirement';
export let requirement_personal = 'Personal';
export let requirement_business = 'Business';
export let requirement_error = 'Select requirement type';
export let personal_user_label = 'Personal User';
export let business_user_label = 'Business User';

export let estimate_title = 'Get an Estimate';
export let estimate_sub_title =
  'Please fill in the details, so we can provide you with the best of our services';
export let estimate_title_mobile = 'How can we help you?';
export let estimate_sub_title_mobile =
  'Please pick a service we can help you with.';

export let two_wheeler_title = 'Two Wheeler';
export let two_wheeler_sub_title = estimate_sub_title;
export let two_wheeler_title_mobile = 'Your Quote is a step away!';
export let two_wheeler_sub_title_mobile = 'is 1 step away';

export let trucks_title = 'Trucks';
export let trucks_sub_title = estimate_sub_title;
export let trucks_title_mobile = two_wheeler_title_mobile;
export let trucks_sub_title_mobile = two_wheeler_sub_title_mobile;

export let pnm_title = 'Packers & Movers';
export let pnm_sub_title = estimate_sub_title;
export let pnm_title_mobile = two_wheeler_title_mobile;
export let pnm_sub_title_mobile = two_wheeler_sub_title_mobile;

export let courier_title = 'Intercity Courier Service';
export let courier_sub_title = estimate_sub_title;
export let courier_title_mobile = two_wheeler_title_mobile;
export let courier_sub_title_mobile = two_wheeler_sub_title_mobile;

export const FareEstimateCategory = 'Fare Estimate V2';
export let two_wheeler_submit_ga_event_name =
  'Get Trip Estimate Click - Home 2W';
export let trucks_submit_ga_event_name =
  'Get Trip Estimate Click - Home Trucks';
export let pnm_submit_ga_event_name = 'Get Trip Estimate Click - PNM';
export let form_submit_ga_event_prefix = 'Get Trip Estimate Click - ';

export let requirement_dropdown_image_alt = 'Requirement selector arrow icon';
export let recaptcha_error_message_text =
  'Error in fetching token. Please refresh the page.';

export let two_wheeler_source = 'home_2W';
export let trucks_wheeler_source = 'home_Trucks';
export let vehicle_trucks_source = 'trucks_fare_estimate';
export let vehicle_2w_source = 'two_wheelers_fare_estimate';
export let spot_source = 'fare_estimate_booking_flow';
export let fare_retry_source = 'Fare Estimate Edit/Retry';
export const moe_fe_est_result_cta_confirm = 'fe_est_result_cta_confirm';

export const whatsappConsentText =
  'By checking this, you give consent to Porter to reach out to you via phone/WhatsApp to help with booking, etc';

export const partloadLeadSuccess = {
  icon: 'https://nest-platform-assets.porter.in/order_success_emphasis_61a6c2eb01/order_success_emphasis_61a6c2eb01.svg',
  title: 'Thanks for your interest!',
  message: 'Our team will get back to you shortly with your estimate.',
  description: 'Intercity Part Load service starts from ₹2 per kg — easy, affordable, reliable.',
};
